import { CommonInstallflowFrame } from "./common-install-flow-frame";
import { HTMLAttributes } from "react";

interface AuthProps extends HTMLAttributes<HTMLDivElement> {}

export function MatchExistingAsset({ className }: AuthProps) {
  return (
    <CommonInstallflowFrame>
      <div className="flex flex-col items-center justify-center gap-6 pt-[200px]">
        <h2 className="text-xl font-bold text-black leading-[26px]">
          Our records indicate a Thalo sensor was already installed on this
          asset.
        </h2>
        <div className="flex flex-col gap-2 w-full">
          <button className="bg-white border-black-100 border-2 text-black w-full p-4 rounded-[12px] text-base font-semibold text-left leading-[26px]">
            This asset already has a sensor installed—I would like to de-install
            the existing sensor and install the new sensor.
          </button>
          <button className="bg-white border-black-100 border-2 text-black w-full p-4 rounded-[12px] text-base font-semibold text-left leading-[26px]">
            I don’t see a sensor installed on this asset.
          </button>
        </div>
      </div>
    </CommonInstallflowFrame>
  );
}
